import * as yup from '@if/core/yup'

export interface PlaceholderDefinitionDto {
  key: string
  financingPrograms: string[]
}

export interface TemplateMessageResponseDto {
  id: string
  code: string
  messageFr: string
  messageEn: string
  category: string
  financingProgramIds?: string[]
  originSystemIds?: string[]
  createdAt?: Date
  createdBy?: string
  updatedAt?: Date
  updatedBy?: string
  lastUsedByCurrentUserAt?: Date
}

export interface TemplateMessageRequestDto {
  Code?: string | null
  MessageFr: string
  MessageEn: string
  Category: string
  FinancingProgramIds: string[]
  OriginSystemIds: string[]
}

export interface TemplateMessageDataDto {
  messages: TemplateMessageResponseDto[]
  placeholders: PlaceholderDefinitionDto[]
}

export const buildTemplateMessageSchema = (allPlaceholders: PlaceholderDefinitionDto[]) => {
  const validatePlaceholders = function (this: yup.TestContext, value: string | undefined) {
    const financingProgramIds: string[] = (this.parent as TemplateMessageRequestForm).FinancingProgramIds ?? []
    if (!value || allPlaceholders.length === 0 || financingProgramIds.length === 0) return true
    const regex = /\{([a-zA-Z0-9_.]+)\}/g
    for (const match of [...value.matchAll(regex)]) {
      const key = match[1]
      const def = allPlaceholders.find(p => p.key === key)
      if (!def) return false
      if (def.financingPrograms.length > 0 && !financingProgramIds.every(p => def.financingPrograms.includes(p))) return false
    }
    return true
  }

  return yup.object({
    Code: yup.string().nullable().notRequired(),
    MessageFr: yup.string().required().test('valid-placeholders', () => 'instantMessage.invalidPlaceholder', validatePlaceholders),
    MessageEn: yup.string().required().test('valid-placeholders', () => 'instantMessage.invalidPlaceholder', validatePlaceholders),
    Category: yup.string().required(),
    FinancingProgramIds: yup.array().of(yup.string().required()).min(1).required(),
    OriginSystemIds: yup.array().of(yup.string().required()).min(1).required(),
  })
}

export interface TemplateMessageRequestForm {
  Code?: string | null
  MessageFr: string
  MessageEn: string
  Category: string
  FinancingProgramIds: string[]
  OriginSystemIds: string[]
}
